// Recognition view: elected roles, the one award shown, press, and credentials.
// Awards other than the Gold Stevie are omitted deliberately.

const SOCIETIES = [
	{
		role: "Senior Member",
		name: "Institute of Electrical and Electronics Engineers, USA",
		logo: "/IEEE-Logo.png",
		alt: "IEEE",
		link: "https://www.ieee.org/",
	},
	{
		role: "Fellow",
		name: "Institution of Engineering and Technology, UK",
		logo: "/IET-Logo.png",
		alt: "IET",
		link: "https://www.theiet.org/",
	},
	{
		role: "Fellow",
		name: "BCS, The Chartered Institute for IT, UK",
		logo: "/BCS-logo.png",
		alt: "BCS",
		link: "https://www.bcs.org/",
	},
	{
		role: "Active contributor",
		name: "OWASP Top 10 for Large Language Model Applications",
		logo: "/OWASP-logo.png",
		alt: "OWASP",
		link: "https://owasp.org/www-project-top-10-for-large-language-model-applications/",
	},
	{
		role: "AI Advisory Board",
		name: "Security Industry Association",
		logo: "/SIA-logo.png",
		alt: "SIA",
		link: "https://www.securityindustry.org/committee/ai-advisory-board/",
	},
	{
		role: "AI Advisory Member",
		name: "IEEE Industry Engagement Committee",
		logo: "/IEEE-IEC.png",
		alt: "IEEE IEC",
		link: "https://www.ieee.org/about/corporate/industry-engagement-committee.html",
	},
];

const AWARD = {
	title: "Gold Stevie Award",
	description: "2024 Stevie Awards for Technology Excellence.",
	logo: "/Stevie-logo.png",
	alt: "Stevie Awards",
	linkText: "Press release ↗",
	link: "https://markets.businessinsider.com/news/stocks/anjanava-biswas-honored-as-gold-stevie-award-winner-in-2024-stevie-awards-for-technology-excellence-1033721322",
};

// `wordmark` renders a two-line mono wordmark where no logo asset exists.
const PRESS = [
	{
		publication: "USA Today",
		logo: "/usatoday.png",
		title: "From research to real-world impact: how Anjanava Biswas is shaping the future of AI",
		link: "https://www.usatoday.com/story/special/contributor-content/2024/08/06/from-research-to-real-world-impact-how-anjanava-biswas-is-shaping-the-future-of-ai/74692376007/",
	},
	{
		publication: "Digital Journal",
		logo: "/dj-logo.png",
		title: "Anjanava Biswas leads the charge in AI innovation and industry standards development",
		link: "https://www.digitaljournal.com/article/anjanava-biswas-leads-the-charge-in-ai-innovation-and-industry-standards-development/",
	},
	{
		publication: "CEO World Magazine",
		logo: null,
		wordmark: ["CEO World", "Magazine"],
		title: "Beyond chatbots: how this AI professional is making a difference amidst the rush for generative AI",
		link: "https://ceoworld.biz/2024/08/22/beyond-chatbots-how-this-ai-professional-is-making-a-difference-amidst-the-rush-for-generative-ai/",
	},
];

const CREDENTIALS = [
	{
		heading: "AWS",
		basis: "1 1 260px",
		body: "Solutions Architect Professional · Machine Learning Specialty · Data Analytics Specialty · Developer Associate · SysOps Administrator Associate",
	},
	{
		heading: "TOGAF & Azure",
		basis: "1 1 200px",
		body: "TOGAF Certified Enterprise Architect, Levels 1 and 2 · Microsoft Certified Azure Professional",
	},
	{
		heading: "Education",
		basis: "1 1 200px",
		body: "B.Tech, Information Technology, Sikkim Manipal Institute of Technology",
	},
];

export { SOCIETIES, AWARD, PRESS, CREDENTIALS };
